<template>
  <vx-card class="mt-base mb-5" title="2. Prone Bridge">
    <p class="mb-5">
      The prone bridge or plank is a great exercise to strengthen your core. Seeing how long you can
      hold this position gives a good indication of the muscular endurance of the abdominal muscles.
      Read through the details below to find out how to do it:
    </p>

    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5">
        <img
          src="@/assets/images/experiences/policing/info2.png"
          alt="Prone bridge. Goal: you will need to hold the bridge position, maintaining a straight line from shoulders through the hips, knees and toes, for 60 seconds. How: to adopt the prone bridge, lie face down, align your toes under your ankles and place your forearms under your shoulders. Then lift your body in a straight line, balanced on your forearms and toes while looking at your hands. Hold this position for 60 seconds. Why: to measure your core strength. Tip: be sure to maintain a straight body position and train to hold this position for more than the 60 seconds required."
          class="mx-auto img-responsive"
        />
      </div>
    </div>

    <p class="mb-5">
      The amount of time you may be required to hold the prone bridge position will vary from force
      to force. For example, while the Victoria Police selection process will require a 60-second
      prone bridge hold, for the Queensland Police selection process candidates must complete a
      90-second prone bridge hold.
    </p>
    <p class="mb-5">
      Watch the video below to see a detailed breakdown of good technique for the prone bridge hold.
    </p>
    <div class="vx-row my-5 flex items-center justify-center">
      <div class="vx-col xl:w-1/2 lg:w-2/3 w-full my-5 text-center">
        <responsive-iframe-youtube :src="videos[1]" :posterimg="videoTrigger1" />
      </div>
    </div>

    <p class="my-5" style="font-size: 110%">
      <strong><u>Prone Bridge Progressive Training Programme</u></strong>
    </p>
    <h4 class="mb-5"><strong>Prone Bridge From Knees Variation</strong></h4>
    <p class="mb-5">
      If you are having trouble performing a prone bridge with good form, you can start from your
      knees and practice the hold each day until your body gets strong enough to perform the full
      prone bridge.
    </p>
    <h4 class="mb-5"><strong>Prone Bridge Full Hold</strong></h4>
    <p class="mb-5">
      Your aim is to be able to hold the prone bridge for a total of 90 seconds with good form. If
      you can already do this, then you can work to extend the time beyond your current
      capabilities. The minimum requirements are just that. Remember - the stronger and fitter you
      are, the better you’ll be able to perform your duties as a police officer.
    </p>
    <p class="mb-5">
      Use the Physical Training Record Sheet to record your results across the week. Try to make a
      little improvement each day. For example, if you are capable of a 30-second hold on Day 1, try
      to push this to 35 seconds on Day 2 and so on.
    </p>
    <h4 class="mb-5">
      <strong>Remember to record your results on the Physical Training Record Sheet.</strong>
    </h4>

    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-checkbox v-model="confirmed" name="confirmed"
          >I have read all the information on this page
        </vs-checkbox>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <button class="btn btn-secondary btn-size-medium mb-1" @click="$router.back()">Back</button>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      videoTrigger1: require('@/assets/images/experiences/policing/prone_bridge.jpg'),
      videos: {
        1: 'https://www.youtube.com/embed/32IDn122Mv0',
      },
      confirmed: false,
    };
  },
  methods: {},
};
</script>
